// Copyright (c) 2017 Deere & Company

import intersectionBy from 'lodash.intersectionby';

const testStringMatch = (value, testValue) =>
    value.toLowerCase().indexOf(testValue.toLowerCase()) !== -1;

const testDealerLocation = (dealer, text) =>
    testStringMatch(dealer.location.city, text) ||
    testStringMatch(dealer.location.state, text) ||
    testStringMatch(dealer.location.country, text);

const testDealerAttributes = (dealer, text) =>
    testStringMatch(dealer.account, text) ||
    testStringMatch(dealer.name, text) ||
    testStringMatch(dealer.industryIndicator, text);

const testDisplayedDealer = (dealer, text) =>
    text === '' ||
    testDealerAttributes(dealer, text) ||
    testDealerLocation(dealer, text);

export const getDisplayedDealers = (dealers, inputText) =>
    dealers.filter(
        dealer => testDisplayedDealer(dealer, inputText)
    );

export const getSelectedDisplayedDealers = dealerAccountsFacet =>
    intersectionBy(dealerAccountsFacet.selectedDealers, dealerAccountsFacet.displayedDealers, 'account');

export const isDealerFacetInvalid = facets =>
    facets.selectedDealers.length === 0 ||
        getSelectedDisplayedDealers(facets).length === 0;



// WEBPACK FOOTER //
// ./src/shared/services/facets.js